import { getDefaultSPPageContext } from './getDefaultSPPageContext';
import {
    DataRequestor,
    IDataRequestorParams,
} from '@ms/odsp-datasources/lib/dataSources/base/DataRequestor';
import { SharingDataSource } from '@ms/odsp-datasources/lib/dataSources/sharing/SharingDataSource';
import { SharingProvider } from '@ms/odsp-datasources/lib/providers/sharing/SharingProvider';
import { ClientId, Mode } from '@ms/odsp-shared-sharing/lib/interfaces/SharingInterfaces';
import { Api } from '@ms/odsp-utilities/lib/logging/events/Api.event';
import { Qos } from '@ms/odsp-utilities/lib/logging/events/Qos.event';
import { WebSharedAriaTelemetryHandler } from '@ms/telemetry-addon-aria/lib/WebSharedAriaTelemetryHandler';
import { IManager } from '@ms/telemetry-manager/lib/Manager';
import { getFileProviderAuthHeaderValue } from 'owa-fileprovider-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

// The space here is important.
const BEARER_PREFIX = 'Bearer ';

export async function getDefaultSharingProvider(
    webUrl: string,
    itemUrl: string,
    manager: IManager
) {
    const spPageContext = await getDefaultSPPageContext(webUrl);
    let token;
    try {
        const fullToken = await getFileProviderAuthHeaderValue(
            AttachmentDataProviderType.OneDrivePro,
            false,
            webUrl
        );
        token = fullToken.split(BEARER_PREFIX)[1];
    } catch {
        // Do nothing. The dialog will open with a 'something went wrong' which is true.
        // If the auth token isn't available at all we wouldn't have made it this far.
    }

    const sharingContextInformation = {
        authToken: token,
        webAbsoluteUrl: webUrl,
        userDisplayName: '',
        isODB: true,
        itemName: '',
        isMacV4ExperimentOn: false,
        organizationName: '',
        clientId: ClientId[ClientId.outlookWeb],
        itemUrl: itemUrl,
        mode: Number(Mode.linkSettings),
        defaultRecipients: [],
    };

    const telemetryHandler = new WebSharedAriaTelemetryHandler({
        clientName: ClientId[ClientId.outlookWeb],
        userAuthToken: token,
    });

    telemetryHandler.attach(manager);

    const sharingDataSource = new SharingDataSource(
        {
            pageContext: spPageContext,
            getParentListId: getParentListId,
            sharingContextInformation: sharingContextInformation,
        },
        {
            pageContext: spPageContext,
            dataRequestorType: class extends DataRequestor {
                constructor(params: IDataRequestorParams) {
                    super(params, {
                        pageContext: spPageContext,
                        qosEvent: Qos.withManager(manager),
                        apiEvent: Api.withManager(manager),
                    });
                }
            },
        }
    );

    return new SharingProvider({
        pageContext: spPageContext,
        getParentListId: getParentListId,
        itemProvider: null,
        sharingDataSource: sharingDataSource,
    });
}

function getParentListId(item: any) {
    return null;
}
